import React, { FC, useMemo } from 'react'
import moment from 'moment'
import { Box, Typography, makeStyles } from 'transfix-ui/core'
import { brandColors } from 'transfix-ui/theme/colors'
import { BidResponse } from 'apps/fleet-planner/types/apiTypes'
import { formatCurrency } from 'utils/formatCurrency'

interface IBidsProps {
  bid: BidResponse
}

const useBidsStyles = makeStyles(() => ({
  info: {
    color: brandColors.info,
  },
  coolGray6: {
    color: brandColors.coolGray6,
  },
  coolGray5: {
    color: brandColors.coolGray5,
  },
}))

export const Bids: FC<IBidsProps> = ({ bid }) => {
  const classes = useBidsStyles()
  const { acceptedBidExpiredAt = 0, amount = '', status } = bid || {}
  const expiredAtDuration = useMemo(
    () => Math.round(moment.duration(acceptedBidExpiredAt, 'seconds').asMinutes()),
    [acceptedBidExpiredAt]
  )
  return (
    <Box>
      <Box pb={0.5}>
        <Typography
          className={status === 'declined' ? classes.coolGray5 : classes.info}
          variant='subtitle1'>
          {`Bid ${formatCurrency(amount)}`}
        </Typography>
      </Box>
      {status === 'accepted' && (
        <Typography className={classes.info} variant='subtitle2'>
          {acceptedBidExpiredAt ? `Expires in ${expiredAtDuration} min` : 'Expires soon'}
        </Typography>
      )}
      {status !== 'accepted' && (
        <Typography
          className={status === 'pending' ? classes.coolGray6 : classes.coolGray5}
          variant='subtitle2'>
          Your Bid
        </Typography>
      )}
    </Box>
  )
}
